import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import Landing from "@/pages/Landing";
import Signup from "@/pages/Signup";
import TenantLogin from "@/pages/TenantLogin";
import UnifiedLogin from "@/pages/UnifiedLogin";
import SharedPunch from "@/pages/SharedPunch";
import Flyer from "@/pages/Flyer";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import SuperAdminLogin from "@/pages/SuperAdminLogin";
import SuperAdminDashboard from "@/pages/SuperAdminDashboard";
import EmployeeDashboard from "@/pages/EmployeeDashboard";
import MonthlyView from "@/pages/MonthlyView";
import TenantAdminDashboard from "@/pages/TenantAdminDashboard";
import BillingSetup from "@/pages/BillingSetup";
import BillingSuccess from "@/pages/BillingSuccess";
import ImpersonationBanner from "@/components/ImpersonationBanner";
import { ProtectedTenant, ProtectedSuper } from "@/components/Protected";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ImpersonationBanner />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<UnifiedLogin />} />
          <Route path="/flyer" element={<Flyer />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/super/login" element={<SuperAdminLogin />} />
          <Route path="/super/dashboard" element={<ProtectedSuper><SuperAdminDashboard /></ProtectedSuper>} />
          <Route path="/t/:slug/login" element={<TenantLogin />} />
          <Route path="/t/:slug/punch" element={<SharedPunch />} />
          <Route path="/t/:slug" element={<SharedPunch />} />
          <Route path="/t/:slug/" element={<SharedPunch />} />
          <Route path="/t/:slug/monthly" element={<ProtectedTenant><MonthlyView /></ProtectedTenant>} />
          <Route path="/t/:slug/admin" element={<ProtectedTenant requireAdmin><TenantAdminDashboard /></ProtectedTenant>} />
          <Route path="/t/:slug/billing/setup" element={<ProtectedTenant requireAdmin><BillingSetup /></ProtectedTenant>} />
          <Route path="/t/:slug/billing/success" element={<ProtectedTenant requireAdmin><BillingSuccess /></ProtectedTenant>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
